<template>
    <div class="collection-host">
        <Message v-if="readFailure" severity="error" :closable="false" class="collection-host__error">
            {{ readFailure }}
        </Message>

        <AdminCollectionLayout
            class="collection-host__layout"
            :config="config"
            controlled
            search-ui="bar"
            :simplify-when-small="false"
            @update:query="onQuery"
        >
            <template #instance="{ record, fieldDefinitions, fieldMeta }">
                <HumanInstanceBody
                    :record="record"
                    :store="store"
                    :field-definitions="fieldDefinitions"
                    :field-meta="fieldMeta"
                />
            </template>
        </AdminCollectionLayout>

        <Paginator
            v-if="store.totalCount > pageSize"
            class="collection-host__paginator"
            :rows="pageSize"
            :total-records="store.totalCount"
            :first="(page - 1) * pageSize"
            @page="(event) => goToPage(event.page + 1)"
        />
    </div>
</template>

<script setup>
import { humansStore } from '@hds/identity-client-sdk'
import Message from 'primevue/message'
import Paginator from 'primevue/paginator'

import AdminCollectionLayout from '@/admin-collection-layout/components/AdminCollectionLayout.vue'
import HumanInstanceBody from '@/components/identity/HumanInstanceBody.vue'
import { useIdentityCollection } from '@/composables/useIdentityCollection.js'
import { HUMANS } from '@/lib/identityCollections.js'

// Humans, the way the five administration nouns are shown: the same search bar, list and
// instance panel over the identity server's list of people. The surface is written in
// `identityCollections.js` rather than read from the server, which publishes none, and the
// layout fires `@update:query` as it mounts, which is what reads the first page.
const props = defineProps({
    title: { type: String, required: true }
})

const store = humansStore()
const { config, onQuery, readFailure, page, pageSize, goToPage } = useIdentityCollection({
    store,
    descriptor: HUMANS,
    title: props.title,
    storageKey: 'humans'
})
</script>

<style scoped>
.collection-host {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
}

.collection-host__error {
    flex: 0 0 auto;
    margin: 16px 16px 0;
}

.collection-host__layout {
    flex: 1 1 auto;
    min-height: 0;
}

.collection-host__paginator {
    border-top: 1px solid var(--p-content-border-color);
    flex: 0 0 auto;
}
</style>
